import React from "react";
import { ActionButtonProps } from "../../types";

export const ActionButton = (props: ActionButtonProps) => {
    const {icon, text, action, classNames} = props;
    const classes = classNames || [""]

   return(
      <div className={["btn", classes].join(" ")} onClick={action}>
          {icon}
          {text && <p>{text}</p>}
      </div>
   )
} 